import { StaticImage } from "gatsby-plugin-image"
import * as React from "react"

export const OurMoments = () => {
  return (
    <>
      <div className="container mx-auto w-[70%] py-10 mt-10">
        <h1 className="lg:text-5xl md:text-2xl sm:text-sm text-[16px] text-nowrap text-black font-semibold text-center">
          Celebrating Success &{" "}
          <span className="text-gradient-secondary">Innovation</span> 🎉
        </h1>
        <div className="lg:my-4 my-2 w-full">
          <p className="text-center text-black lg:text-sm text-[7px]">
            At Visual Folio, every project, milestone, and achievement is a
            moment to celebrate. From groundbreaking ideas to successful
            launches, we take pride in the journey we share with our clients.
            Join us as we create, innovate, and make every moment count!
          </p>
        </div>
      </div>
      <div className="container mx-auto px-3 lg:px-0 flex flex-wrap lg:gap-5 md:gap-4 sm:gap-3 gap-3">
        <div className="lg:w-[32%] md:w-[32%] sm:w-[49%] w-[48%] flex justify-center">
          <StaticImage
            placeholder="blurred"
            className="w-full"
            src="./life-in-future.png"
            alt="life-in-future"
          />
        </div>
        <div className="lg:w-[32%] md:w-[32%] sm:w-[49%] w-[48%] flex justify-center">
          <StaticImage
            placeholder="blurred"
            className="w-full"
            src="./technology-bring-togather.png"
            alt="technology-bring-togather"
          />
        </div>
        <div className="lg:w-[32%] md:w-[32%] sm:w-[49%] w-[48%] flex justify-center">
          <StaticImage
            placeholder="blurred"
            className="w-full"
            src="./digital.png"
            alt="technology-bring-togather"
          />
        </div>
        <div className="lg:w-[32%] md:w-[32%] sm:w-[49%] w-[48%] flex justify-center">
          <StaticImage
            placeholder="blurred"
            className="w-full"
            src="./convenience.png"
            alt="technology-bring-togather"
          />
        </div>
        <div className="lg:w-[32%] md:w-[32%] sm:w-[49%] w-[48%] flex justify-center">
          <StaticImage
            placeholder="blurred"
            className="w-full"
            src="./normalcy.png"
            alt="technology-bring-togather"
          />
        </div>
        <div className="lg:w-[32%] md:w-[32%] sm:w-[49%] w-[48%] flex justify-center">
          <StaticImage
            placeholder="blurred"
            className="w-full"
            src="./breakout.png"
            alt="technology-bring-togather"
          />
        </div>
        <div className="lg:w-[32%] md:w-[32%] sm:w-[49%] w-[48%] flex justify-center">
          <StaticImage
            placeholder="blurred"
            className="w-full"
            src="./listen.png"
            alt="technology-bring-togather"
          />
        </div>
        <div className="lg:w-[32%] md:w-[32%] sm:w-[49%] w-[48%] flex justify-center">
          <StaticImage
            placeholder="blurred"
            className="w-full"
            src="./behind.png"
            alt="technology-bring-togather"
          />
        </div>
        <div className="lg:w-[32%] md:w-[32%] sm:w-[49%] w-[48%] flex justify-center">
          <StaticImage
            placeholder="blurred"
            className="w-full"
            src="./play.png"
            alt="technology-bring-togather"
          />
        </div>
      </div>
    </>
  )
}
